import * as React from 'react'
import { cn } from '@/lib/utils'
import { useFormFieldControl } from '@/components/shared/form-field'

export const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    const field = useFormFieldControl(props)
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'flex h-10 w-full rounded-xl border border-input bg-background px-3 py-2 text-sm shadow-sm transition-all duration-200 outline-none placeholder:text-muted-foreground/60 focus-visible:ring-2 focus-visible:ring-primary/10 focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        {...props}
        {...field}
      />
    )
  },
)
Input.displayName = 'Input'
